module.exports = __webpack_public_path__ + "site/img/143.56696a35.jpg";